export { BookmarkAlt as default } from './BookmarkAlt';
